var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import WindowConfigContext from '../../context/window-config-context';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
var StyledTreeWidget = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  display: ", ";\n  flex-direction: ", ";\n  border: ", ";\n  border-color: ", ";\n  border-collapse: ", ";\n  border-spacing: ", ";\n  overflow: ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  ", "\n  display: ", ";\n  flex-direction: ", ";\n  border: ", ";\n  border-color: ", ";\n  border-collapse: ",
    ";\n  border-spacing: ", ";\n  overflow: ", ";\n  background-color: ",
    ";\n  color: ", ";\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.flexDirection;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.borderColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.borderCollapse;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.borderSpacing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.overflow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.color;
});
var StyledTreeWidgetUL = styled.ul.attrs(function (props) { return ({
    className: props.className,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: ", ";\n  height: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  list-style-type: ", ";\n  cursor: ", ";\n  &.nested {\n    display: ", ";\n  }\n"], ["\n  overflow: ", ";\n  height: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  list-style-type: ",
    ";\n  cursor: ", ";\n  &.nested {\n    display: ", ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.overflow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.marginTop;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.marginBottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.listStyleType;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.display;
});
var StyledTreeWidgetLI = styled.li.attrs(function (props) { return ({}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  background-color: ", ";\n"], ["\n  margin-bottom: ",
    ";\n  background-color: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.marginBottom;
}, function (_a) {
    var windowTheme = _a.windowTheme, isSelectedRow = _a.isSelectedRow;
    return isSelectedRow ? windowTheme.treeWidget.ul.li.selectedBgColor : '';
});
var StyledTreeHeader = styled.div.attrs(function (props) { return ({}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: ", ";\n  padding-left: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  color: ", ";\n  > span {\n    vertical-align: ", ";\n  }\n"], ["\n  flex: ", ";\n  padding-left: ",
    ";\n  background-color: ",
    ";\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  color: ", ";\n  > span {\n    vertical-align: ",
    ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.flex;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.paddingLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.borderLeftColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.borderTopColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.header.span.verticalAlign;
});
var StyledTreeWidgetNestedLI = styled.li.attrs(function (props) { return ({}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  &::before {\n    content: ", ";\n    color: ", ";\n    display: ", ";\n    margin-right: ", ";\n  }\n  &.carat-down::before {\n    -ms-transform: ", "; /* IE 9 */\n    -webkit-transform: ", "; /* Safari */'\n    transform: ", ";; \n  }\n"], ["\n  margin-bottom: ",
    ";\n  &::before {\n    content: ",
    ";\n    color: ", ";\n    display: ",
    ";\n    margin-right: ",
    ";\n  }\n  &.carat-down::before {\n    -ms-transform: ",
    "; /* IE 9 */\n    -webkit-transform: ",
    "; /* Safari */'\n    transform: ",
    ";; \n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.marginBottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return "\"" + windowTheme.treeWidget.ul.li.nested.content + "\"";
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.nested.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.nested.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.nested.marginRight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.caratDown.transform;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.caratDown.transform;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.treeWidget.ul.li.caratDown.transform;
});
var toggleNestedElement = function (e, text) {
    e.currentTarget.classList.toggle('carat-down');
    e.stopPropagation();
    var ele = document.querySelector("#" + text);
    if (ele) {
        ele.style.display =
            !ele.style.display ||
                ele.style.display === '' ||
                ele.style.display === 'none'
                ? 'block'
                : 'none';
    }
};
var getTreeContent = function (stateFields, identifier, items) {
    if (stateFields[identifier]) {
        return stateFields[identifier];
    }
    return items || [];
};
var Content = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  justify-content: space-between;\n"], ["\n  justify-content: space-between;\n"])));
var TreeWidgetLI = function (props) {
    var items = props.items, selectedRow = props.selectedRow, onSelect = props.onSelect, identifier = props.identifier, restProps = __rest(props, ["items", "selectedRow", "onSelect", "identifier"]);
    return items.map(function (li, index) {
        var attributes = li.attributes, item = li.item, restLiProps = li.restLiProps;
        var text = attributes.text;
        if (item && item.length) {
            var id_1 = identifier + "-" + text.replace(/[&\/\\#, +()$~%.'":*?\[\]<>{}]/g, '_');
            return (React.createElement(StyledTreeWidgetNestedLI, __assign({ key: li.text + "-" + index }, restProps, { onClick: function (e) { return toggleNestedElement(e, id_1); } }),
                React.createElement(Content, null, Object.values(attributes).join('  :  ')),
                React.createElement(TreeWidgetUL, __assign({ identifier: identifier, onSelect: onSelect, selectedRow: selectedRow, id: id_1, items: item }, restLiProps, restProps, { className: "nested" }))));
        }
        return (React.createElement(StyledTreeWidgetLI, __assign({ identifier: identifier, key: li.text + "-" + index }, restProps, { isSelectedRow: selectedRow === text, onClick: function (e) { return onSelect(e, text); } }),
            React.createElement(Content, null, Object.values(attributes).join('  :  '))));
    });
};
var TreeWidgetUL = function (props) {
    var items = props.items, id = props.id, selectedRow = props.selectedRow, onSelect = props.onSelect, className = props.className, identifier = props.identifier, restProps = __rest(props, ["items", "id", "selectedRow", "onSelect", "className", "identifier"]);
    if (items && items.length > 0) {
        return (React.createElement(StyledTreeWidgetUL, __assign({}, restProps, { className: className, id: id }),
            React.createElement(TreeWidgetLI, __assign({ identifier: identifier, items: items, selectedRow: selectedRow, onSelect: onSelect }, restProps))));
    }
    return null;
};
var TreeHeader = function (props) {
    var column = props.column, restProps = __rest(props, ["column"]);
    var text = column[0].attributes.text;
    return (React.createElement(StyledTreeHeader, __assign({}, restProps),
        React.createElement("span", null, text)));
};
var TreeWidget = function (props) {
    var attributes = props.attributes, column = props.column, item = props.item, restProps = __rest(props, ["attributes", "column", "item"]);
    var _a = useState(undefined), selectedRow = _a[0], updateSelectedRow = _a[1];
    var stateFromEnv = useContext(WindowStateContext);
    var _onTreeContainerClick = useContext(WindowEventContext)._onTreeContainerClick;
    var config = useContext(WindowConfigContext);
    var treeContent = getTreeContent(stateFromEnv.fields, restProps.identifier, item);
    var onSelect = function (e, text) {
        e.stopPropagation();
        updateSelectedRow(text);
    };
    var handleTreeContainerClick = function () {
        console.log('clicked tree container');
        config.isBuilder && _onTreeContainerClick(props.identifier);
    };
    return (React.createElement(StyledTreeWidget, __assign({}, restProps, { attributes: attributes, onClick: handleTreeContainerClick }),
        React.createElement(TreeHeader, __assign({ column: column }, restProps)),
        React.createElement(TreeWidgetUL, __assign({ selectedRow: selectedRow, items: treeContent, onSelect: onSelect }, restProps, { className: "topUl" }))));
};
export default TreeWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map